module.exports = __webpack_public_path__ + "img/logo.c1367942.png";